import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { userSettingsEntity } from './user-settings.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as UserSettingsActions from './user-settings.actions';

export const USER_SETTINGS_FEATURE_KEY = 'userSettings';

export interface UserSettingsState extends EntityState<userSettingsEntity> {
  userSettings: userSettingsEntity | null;
  loaded: boolean;
  error?: string | null;
}

export const userSettingsAdapter: EntityAdapter<userSettingsEntity> = createEntityAdapter<userSettingsEntity>();

export const initialUserSettingsState: UserSettingsState = userSettingsAdapter.getInitialState({
  userSettings: null,
  loaded: true,
  error: null,
});

const reducer = createReducer(
  initialUserSettingsState,
  on(UserSettingsActions.loadUserSettings, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserSettingsActions.loadUserSettingsSuccess, (state, { userSettings }) => ({
    ...state,
    userSettings: userSettings,
    loaded: true,
    error: null,
  })),
  on(UserSettingsActions.loadUserSettingsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(UserSettingsActions.setUserSettings, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserSettingsActions.setUserSettingsSuccess, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(UserSettingsActions.setUserSettingsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(UserSettingsActions.deleteUserSettings, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(UserSettingsActions.deleteUserSettingsSuccess, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(UserSettingsActions.deleteUserSettingsFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  }))
);

export function userSettingsReducer(state: UserSettingsState | undefined, action: Action) {
  return reducer(state, action);
}
